import { render, staticRenderFns } from "./order-draft.vue?vue&type=template&id=ce2a80f6&scoped=true&"
import script from "./order-draft.vue?vue&type=script&lang=js&"
export * from "./order-draft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2a80f6",
  null
  
)

export default component.exports